module.exports = __webpack_public_path__ + "assets/img/bg-male-62f6736d.png";